import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import { useMediaQuery } from "_common/component/MediaQueryProvider";
import HeaderTop from "_common/component/Layout/Header/HeaderTop";
import { useStores } from "_common/hooks";
import { Link } from "react-router-dom";

import bgStaking from "assets/img/bg-staking.png";
import classNames from "classnames";
import FundList from "./FundList";
import FundHistory from "./FundHistory";

const StackingMobile = observer(() => {
  const {
    authStore: { ieo },
  } = useStores();
  const { isMobile } = useMediaQuery();
  const [activeTab, setActiveTab] = useState("tab1");

  return (
    <>
      <HeaderTop title="DeFi" />
      <div className="oreimgbox2">
        <div className="fl col-8 pl20 pt20">
          <p className="fe6im ti12 f12">Nhận ngay phần thưởng khai thác</p>
          <p className="fe6im ti12 f12">Lưu trữ khi cần</p>
          <p className="fe6im ti12 f12">Thao tác linh hoạt</p>
        </div>
        <div className="fr  col-4">
          <img
            src={bgStaking}
            alt=""
            className="d-block"
            style={{ width: 170, float: "right" }}
          />
        </div>
      </div>
      <div className="ieo-page">
        <div className="line-head">
          <div className="oplist2">
            <div
              className={classNames("tab", { active: activeTab === "tab1" })}
              onClick={() => setActiveTab("tab1")}
            >
              Tổng quan
            </div>
            <div
              className={classNames("tab", { active: activeTab === "tab2" })}
              onClick={() => setActiveTab("tab2")}
            >
              Đầu tư của tôi
            </div>
          </div>
        </div>
        {activeTab === "tab1" && <FundList />}
        {activeTab === "tab2" && <FundHistory />}
      </div>
    </>
  );
});

export default StackingMobile;
